

const validateName = (name, isRequired) => {
    // Regular expression for name validation: allows alphabets, spaces, dot and optional hyphen or apostrophe
    const nameRegex = /^[a-zA-Z\s.'-]+$/;
    if (!nameRegex.test(name) || (isRequired && name.trim() === "")) {
        return false;
    }
    return true;
}

const validateEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return false;
    }
    return true;
}

const validatePhoneNumber = (phoneNumber) => {
    // Regular expression for a valid 10-digit Indian phone number starting with 6, 7, 8, or 9.
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
        return false;
    }
    return true;
}

const validateAadhaarNumber = (aadhaarNumber) => {
    // Regular expression for a valid 12-digit Aadhaar number
    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(aadhaarNumber)) {
        return false;
    }
    return true;
}

export const validateFormsFields = (field, formData) => {
    const isRequired = field?.required;
    let errorMessage = "";
    let isValid = true;


    switch (field.name) {
        case "firstName":
        case "lastName":
        case "mMApplicantName":
        case "fathersGuardiansName":
        case "sl1FullName":
        case "sl2FullName":
        case "sl3FullName":
        case "cr1FullName":
        case "cr2FullName":
            if (!validateName(formData, isRequired)) {
                errorMessage = "Name should not be empty or contain invalid characters.";
                isValid = false;
            }
            break;

        case "email":
            if (!validateEmail(formData)) {
                errorMessage = "Invalid email format.";
                isValid = false;
            }
            break;

        case "phone":
        case "phoneNumber":
        case "fathersGuardiansMobileNo":
        case "cr1Phone":
        case "cr2Phone":
            if (!validatePhoneNumber(formData)) {
                errorMessage = "Phone number must be a valid 10-digit number.";
                isValid = false;
            }
            break;

        case "aadharNumber":
            if (!validateAadhaarNumber(formData)) {
                errorMessage = "Aadhaar number must be a 12-digit numeric value.";
                isValid = false;
            }
            break;

        default:
            break;
    }
    return { isValid, errorMessage };
};
